import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-08.jpg";
import aiImg from "../../assets/img/ai-WISscrap.png";
import aiIcon01 from "../../assets/img/icon-ai20.png";
import aiIcon02 from "../../assets/img/icon-ai21.png";
import aiIcon03 from "../../assets/img/icon-ai17.png";
import aiIcon04 from "../../assets/img/icon-ai14.png";
import fwImg from "../../assets/img/fw-wisscrap.png";

function WISscrap() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';


   //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISscrap 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };
  
  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">Nocode기반 데이터 수집/구축 파이프라인</span>
						<h2>WISscrap</h2>
						<p>웹, SNS, 미디어 등으로 부터 Nocode 형태로 데이터를 자동 수집·정제해, 인사이트 발굴 및 예측에 활용하는 데이터 수집/구축 파이프라인입니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISscrap 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISplatform" /></div>
            <div className="info">
              <p>WISscrap은 웹과 SNS 등에서 방대한 데이터를 자동으로 수집하고, 신속하게 정제 및 분석하여 실질적인 비즈니스 인사이트를 제공하는 고도화된 AI 기반 웹 빅데이터 수집·분석 솔루션입니다. 다양한 산업군에서 트렌드 예측, 시장 분석, 위험 탐지, 여론·감성 분석 등 데이터 기반의 의사결정과 자동화에 최적화되어 있습니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">다채널 데이터 수집</p>
                  <p className="txt">웹사이트, 뉴스, 커뮤니티, SNS, 동영상, 오픈데이터 등 다양한 채널의 방대한 데이터 실시간/주기적 크롤링</p>
                </li>
                 <li>
                  <p className="tit">데이터 정제 및 품질 관리</p>
                  <p className="txt">중복 제거, 불필요 항목 필터링, 언어별·포맷별 표준화 개인정보·민감정보 비식별화 및 안전한 저장체계 구현</p>
                </li>
                 <li>
                  <p className="tit">AI 기반 데이터 분석</p>
                  <p className="txt">키워드 추출, 토픽/감성 분석, 트렌드 변화 감지 고급 통계·AI 분석 및 시각화로 인사이트 제공</p>
                </li>
                 <li>
                  <p className="tit">확장성과 연동성</p>
                  <p className="txt">대용량 데이터 수집 및 분산처리로 높은 확장성 기업 내부 DB, ERP, 검색엔진 등 외부 시스템과의 간편 연동</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="크롤링·스크래핑 엔진"/></span>
              <p className="tit">크롤링·스크래핑<br/> 엔진</p>
              <p className="txt">최신 웹 표준 대응 사용자 인증, 프록시, 헤더 설정 등 다수 환경에서 활용 가능</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="고성능 병렬 처리 구조"/></span>
              <p className="tit">고성능<br/>병렬 처리 구조</p>
              <p className="txt">다수의 크롤러·에이전트가 분산 환경에서 동시에 작동 실시간 데이터 스트림 처리 및 LLM/API 기반 자동 분류/분석 지원
</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="비정형 데이터 최적화"/></span>
              <p className="tit">비정형<br/>데이터 최적화</p>
              <p className="txt">정형·비정형 텍스트, 이미지, 댓글, 리뷰 등 다양한 데이터 타입에 최적화 다양한 산업별 도메인 커스터마이징과 맞춤형 분석 모델 적용</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="보안·품질"/></span>
              <p className="tit">보안·품질</p>
              <p className="txt">개인정보 보호/비식별화와 데이터 품질 관리 체계로 신뢰도 보장</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">크롤링 대상</p>
                <p className="txt">웹/SNS/미디어</p>
              </li>
              <li>
                <p className="tit">수집 Agent</p>
                <p className="txt">분산/병렬 모듈</p>
              </li>
              <li>
                <p className="tit">데이터 정제</p>
                <p className="txt">클렌징/비식별화</p>
              </li>
              <li>
                <p className="tit">AI 분석</p>
                <p className="txt">키워드/감성/트렌드/이슈</p>
              </li>
              <li>
                <p className="tit">API 연계</p>
                <p className="txt">시각화/리포트/대시보드</p>
              </li>
              <li>
                <p className="tit">외부 서비스 연계</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework"  onClick={imgClick}>
              <img src={fwImg} alt="WISscrap 프레임워크"/>
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">시장 및 트렌드 예측</p>
                <p className="txt">신제품 출시와 관련된 온라인 여론 및 트렌드, 경쟁사 동향, 고객 반응 분석</p>
              </li>
                <li>
                <p className="tit">여론·감성 분석</p>
                <p className="txt">소셜미디어 데이터를 통한 브랜드 평판, 이슈 자동 탐지</p>
              </li>
                <li>
                <p className="tit">상품·마케팅 관리</p>
                <p className="txt">타겟 고객 발굴, 광고 효과 분석, 리뷰/댓글 실시간 분석으로 상품 개선 및 마케팅 전략 수립</p>
              </li>
                <li>
                <p className="tit">정책·사회 분석</p>
                <p className="txt">공공 데이터와 결합한 정책 효과 분석, 지역 이슈 파악, 다양한 언론사의 기사를 분석</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISscrap;